import React from "react";

import Layout from "@components/Layout/Layout";
import LaMaisonProgress from "@components/TestDrive/TestDriveProgress/LaMaisonProgress";

import { useTestDrivePointSelector } from "@redux/reducers/testDrive";
import { useReferrerSelector } from "@redux/reducers/appConfig";
import { getInitialProps } from "@lib/test-drive/getInitialProps";
import { useTestDrivePointHandler } from "@hooks/test-drive/useTestDrivePointHandler";
import { useTestDriveLocationHandler } from "@hooks/test-drive/useTestDriveLocationHandler";
import { withError } from "@hoc/withError";
import { withTestDriveTypes } from "@hoc/withTestDriveTypes";
import { propTypes } from "@lib/test-drive/propTypes";
import { withTranslation } from "@lib/i18n";

const MaisonPage = ({ pageProps }) => {
  const {
    testDriveLocation,
    parkopolyAvailableSlots,
    testDriveSessionData,
    testDriveExclusionDates,
  } = pageProps;

  const selectedTestDrivePoint = useTestDrivePointSelector();
  const affiliation = useReferrerSelector();

  useTestDrivePointHandler(testDriveLocation);
  useTestDriveLocationHandler(testDriveLocation, selectedTestDrivePoint);

  return (
    <Layout isGetPageNameByPathname>
      <LaMaisonProgress
        affiliation={affiliation}
        parkopolyAvailableSlots={parkopolyAvailableSlots}
        testDriveLocation={testDriveLocation}
        testDriveSessionData={testDriveSessionData}
        testDriveExclusionDates={testDriveExclusionDates}
      />
    </Layout>
  );
};

MaisonPage.getInitialProps = getInitialProps;
MaisonPage.propTypes = propTypes;

export default withError(
  withTestDriveTypes(withTranslation("common")(MaisonPage))
);
